import { useTranslate } from "react-admin";
import { useFormContext } from "react-hook-form";
import {
  GeometrisEngineBusType,
  GeometrisEngineBusTypeInput,
} from "../../../common/data/service-proxies";
import { HookFormSimpleForm } from "../../common/form/hook-form/HookFormSimpleForm";
import { HookFormSelectInput } from "../../common/form/hook-form/inputs/HookFormSelectInput";
import { GeometrisDeviceSelectorInput } from "./GeometrisDeviceSelectorInput";

interface Props {}

const geometrisEngineBusTypes = Object.keys(GeometrisEngineBusType)
  .filter((key) => isNaN(+key))
  .map((x) => ({ id: x, name: x.toUpperCase() }));

export const GeometrisEngineBusCommandForm = (props: Props) => {
  const translate = useTranslate();
  const { control } = useFormContext<GeometrisEngineBusTypeInput>();
  return (
    <HookFormSimpleForm {...props}>
      <GeometrisDeviceSelectorInput<GeometrisEngineBusTypeInput>
        {...props}
        control={control}
      />
      <HookFormSelectInput<GeometrisEngineBusTypeInput>
        {...props}
        control={control}
        name="engineBusType"
        label="Engine bus type"
        rules={{ required: translate("ra.validation.required") }}
        choices={geometrisEngineBusTypes}
        defaultValue={GeometrisEngineBusType.AutoDetect}
      />
    </HookFormSimpleForm>
  );
};
